import { Components, Theme } from '@mui/material';
import spacing from './spacing-options';
import shapeOptions from './shape-options';
import paletteOptions from './palette-options';

const componentsPropsOverrides: Components<Omit<Theme, 'components'>> = {
  // Buttons

  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
  },

  // Sliders

  MuiSlider: {
    defaultProps: {
      color: 'secondary',
    },
  },

  // Text

  MuiTypography: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...((ownerState.color === 'primary' || ownerState.color === 'secondary') && {
          fontWeight: '500',
        }),
      }),
    },
  },

  // Selects

  MuiInputBase: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.startAdornment != null && {
          MuiSelect: {
            marginLeft: `${spacing}px`,
            marginRight: `-${spacing}px`,
          },
        }),
      }),
    },
  },

  // Visual fixes on selects for usage in conjonction with formControl
  // Unfortunately, MuiMenu-paper is not a child of select, so we can't say if it is used with formcontrol or no
  // We choose to favor usage with formcontrol, with in mind it will degrade visual when used without it
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: shapeOptions.borderRadius,
        marginRight: `-${2 * spacing}px`,
        marginLeft: `-${1 * spacing}px`,
        marginTop: `${0.5 * spacing}px`,
        position: 'relative',
      },
    },
  },

  // Autocompletes

  // Visual fixes on autocompletes for usage in conjonction with formControl
  // Unfortunately, MuiAutocomplete-popper and MuiAutocomplete-paper are not children of autocomplete, so we can't say if it is used with formcontrol or no
  // We choose to favor usage with formcontrol, with in mind it will degrade visual when used without it
  MuiAutocomplete: {
    styleOverrides: {
      paper: {
        borderRadius: `${shapeOptions.borderRadius}px`,
        marginRight: `-${2 * spacing}px`,
        marginLeft: `-${2 * spacing}px`,
      },
      popper: ({ ownerState }) => ({
        ...(ownerState.placement == 'top' && {
          marginBottom: '8px',
        }),
        ...(ownerState.placement == 'bottom' && {
          marginTop: '8px',
        }),
      }),
    },
  },

  // Tooltips

  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        fontWeight: 600,
        fontSize: '0.675rem',
        borderRadius: 10,
      },
    },
  },

  // Form control label

  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        marginLeft: `-${spacing}px`,
        marginRight: `${2 * spacing}px`,
      },
    },
  },

  // Snackbar

  MuiSnackbar: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.anchorOrigin.vertical == 'top' &&
          ownerState.anchorOrigin.horizontal == 'center' && {
            top: '50px',
          }),
      }),
    },
  },

  // Divider

  MuiDivider: {
    styleOverrides: {
      root: () => ({
        borderColor: paletteOptions.divider,
      }),
    },
  },
};

export default componentsPropsOverrides;
